import { render, staticRenderFns } from "./ComponentPlantTop.vue?vue&type=template&id=14063de8&scoped=true"
import script from "./ComponentPlantTop.vue?vue&type=script&lang=js"
export * from "./ComponentPlantTop.vue?vue&type=script&lang=js"
import style0 from "./ComponentPlantTop.vue?vue&type=style&index=0&id=14063de8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14063de8",
  null
  
)

export default component.exports